export default {
  endpoint: "https://app.crmbexton.com",
  socket: "https://socket.crmtronline.com",
  appName: "bexton",
  PUSHER_APP_ID: "crmtronline",
  PUSHER_CHNL_ID: "bexton",
  PUSHER_APP_KEY: "crmtronline-key",
  PUSHER_WS_HOST: "pusher.crmtronline.com",
  PUSHER_WS_PORT: 443,
  PUSHER_WSS_PORT: 443,
};
